const InputResult = ({ label, text }: { label: string; text: string }) => (
  <div>
    <p className="text-sm font-regular text-gray-400 mb-1">{label}</p>
    <p className="text-base font-regular text-gray-800">{text}</p>
  </div>
);

export default InputResult;
